import { render } from "./QuizSingle.vue?vue&type=template&id=a4ed55a4"
import script from "./QuizSingle.vue?vue&type=script&lang=js"
export * from "./QuizSingle.vue?vue&type=script&lang=js"
script.render = render

export default script